import { getInstance } from "../core/axios-gateway";

const BASE_PATH = "/api/metrics/consumo-por-supplier";
const ACTIVE_USERS_PATH = "/api/metrics/consumo/active-users";

export interface TSupplierData {
  agents: string[];
  ai_cost: number;
  marketing_cost: number;
  marketing_responses: number;
  marketing_success: number;
  supplier_name: string;
  total_conversations: number;
  total_cost: number;
  total_input_cost: number;
  total_input_tokens: number;
  total_output_cost: number;
  total_output_tokens: number;
  total_tokens: number;
}

export type TConsumoResponse = Record<string, TSupplierData>;

export interface TConsumoParams {
  startDate: string;
  endDate: string;
}

export const getConsumoMetrics = async (params: TConsumoParams) => {
  return getInstance()
    .get<TConsumoResponse>(BASE_PATH, { params })
    .then((res) => res.data);
};

// Active Users types and API call
export interface TActiveUsersUserDetail {
  name: string;
  months: Record<string, number>; // month label → active_days
  total: number;
}

export interface TActiveUsersSupplierMonthData {
  total_users: number;
  active_users: number;
  total_active_days: number;
}

export interface TActiveUsersSupplier {
  supplier_name: string;
  months: Record<string, TActiveUsersSupplierMonthData>;
  users: TActiveUsersUserDetail[];
}

export interface TActiveUsersResponse {
  months: string[];
  thresholds: Record<string, number>;
  suppliers: Record<string, TActiveUsersSupplier>;
}

export const getActiveUsersMetrics = async () => {
  return getInstance()
    .get<TActiveUsersResponse>(ACTIVE_USERS_PATH)
    .then((res) => res.data);
};


